import { fdSelectModelList } from './../../models/fdSelect.model';
import { Component, OnInit } from '@angular/core';
import { UrlService } from '../../shared/services/url.service';
import { UrlControl } from '../../shared/models/generic.model';
import { AlertService } from '../../shared/services/alert.service';
import { GlobalService } from 'src/app/shared/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { fdSelectModel } from 'src/app/models/fdSelect.model';
import { Router, ActivatedRoute } from '@angular/router';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';

@Component({
  selector: 'detalle-grupo-discapacidad',
  templateUrl: './detalle-grupo-discapacidad.component.html',
  styleUrls: ['./detalle-grupo-discapacidad.component.scss']
})

export class DetalleGrupoDiscapacidadComponent implements OnInit {


  public filtroOrdenamiento: string;
  public filtroNombre: string;
  public listaFuncionarios;
  public selectOptions: fdSelectModel;
  public selecComponentOptions: fdSelectModel;
  public filtro: string;
  public elementList = [];
  public idGrupo: string;
  public nombreGrupo: string;

  constructor(private router: Router, private route: ActivatedRoute
    , private urlService: UrlService, private global: GlobalService
    , private spiner: NgxSpinnerService, private alertService: AlertService) {
    this.selectOptions =
      new fdSelectModel('Nombre o número de documento', 'BUSCAR', this.elementList, null, 'Ingesar al grupo');
    this.selecComponentOptions = this.selectOptions;
    this.filtroOrdenamiento = 'DESC';
    this.filtroNombre = null;
  }

  ngOnInit() {
    const datos = this.global.zonaCompartida[VariablesZonaCompartida.DETALLE_GRUPO_DISCAPACIDAD];
    this.idGrupo = datos ? datos.idGrupo : null;
    this.nombreGrupo = datos ? datos.nombreGrupo : null;
    this.getFuncionariosDiscapacidad();
    this.getFuncionariosSinDiscapacidad();
  }

  // fromero
  // método de consulta de funcionarios sin grupo de discapacidad
  // 07/05/2019

  getFuncionariosSinDiscapacidad() {
    this.spiner.show();
    let serviceProvider: string = 'ObtenerFuncionario';
    let queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filterBy=idGrupoDiscapacidad', '0']);
    let url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    this.global.getGenerico(url).subscribe(
      data => {

        let tempArray = data;
        this.elementList = [];
        tempArray.forEach(element => {

          let el: fdSelectModelList = new fdSelectModelList(

            element.nombreCompleto,
            false,
            element.funcionarioPK.numeroIdFuncionario,
            element
          )


          this.elementList.push(el);

        });

        this.listaFuncionarios.forEach(element => {
          element.grupoDiscapacidad = this.nombreGrupo;
        });
        this.spiner.hide();

      }, err => {
        this.cathException('No es posible Obtener Funcionario', err);
      }
    );
  }

  // fromero
  // método de consulta de funcionarios por  Grupo de discapacidad
  // 06/05/2019

  getFuncionariosDiscapacidad() {

    this.spiner.show();
    let serviceProvider: string = 'ObtenerFuncionario';
    let queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filterBy=idGrupoDiscapacidad', this.idGrupo]);

    this.filtroNombre = 'ant';
    if (this.filtroNombre != null && this.filtroNombre != '') {
      queryParams.push(['nombreCompleto', this.filtroNombre])
    }
    // queryParams.push(['orderBy=', this.filtroOrdenamiento]);

    let url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    this.global.getGenerico(url).subscribe(
      data => {

        this.listaFuncionarios = data;

        this.listaFuncionarios.forEach(element => {

          // element.nombreCompleto = this.global.replaceCardTextLine(element.nombreCompleto);
          element.grupoDiscapacidad = this.nombreGrupo;

        });
        this.spiner.hide();

      }, err => {
        this.cathException('No es posible Obtener Funcionario', err);
      }
    );
  }

  // fromero
  // método para eliminar un funcionario
  // 06/05/2019
  public eliminarFuncionario(event) {

    if (event.respuesta[0]) {
      this.spiner.show();
      const obj = event.objeto;
      obj.idGrupoDiscapacidad = 0;
      const serviceProvider = 'ObtenerFuncionario';
      const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
      this.global.putGenerico(url, obj).subscribe(
        data => {
          this.spiner.hide();
          this.alertService.generateAlertSuccess('Se Borro la persona del grupo', '');
          this.getFuncionariosDiscapacidad();
          this.getFuncionariosSinDiscapacidad();
        }, err => {
          this.cathException('No se pudo retirar del grupo', err);
        }
      );
    }
  }

  // fromero
  // método para regresar al listado de Grupos de Discapacidad
  // 06/05/2019
  public regresarListado() {
    this.global.zonaCompartida[VariablesZonaCompartida.DETALLE_GRUPO_DISCAPACIDAD] = undefined;
    this.router.navigate(['/main/configuracion-discapacidad']);
  }


  // fromero
  // método para obtener y guardar  la lista de elementos seleccionados en el filtro
  // 07/05/2019
  public guardarSeleccion(event) {

    this.spiner.show();
    event.elementosSeleccionados.forEach(element => {
      element.idGrupoDiscapacidad = this.idGrupo;
    });

    let objetoPeticion = event.elementosSeleccionados;

    let serviceProvider: string = 'GuardarGrupoFuncionariosDiscapacidad';
    let url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);

    this.global.postGenerico(url, objetoPeticion).subscribe(
      data => {


        this.getFuncionariosSinDiscapacidad();
        this.getFuncionariosDiscapacidad();

        this.alertService.generateAlertSuccess('Se agregó la persona al grupo', '');
        this.spiner.hide();

      }, err => {
        this.cathException('No es posible Agregar Funcionario', err);
      }
    );




  }

  public buscar(event) {
    this.filtro = event.filtro;
  }

  cathException(error, err?) {
    this.alertService.generateAlertError(error, ' ');
    this.spiner.hide();
  }


}
